import React from "react";

export default function TableSkeleton() {
  return (
    <div className="bg-white rounded-lg shadow p-4 mb-2 animate-pulse">
      <div className="h-8 bg-gray-200 rounded w-40 mb-4" /> {/* Table title */}
      {/* Table header row */}
      <div className="flex gap-4 mb-2">
        {[...Array(11)].map((_, i) => (
          <div key={i} className="h-6 w-24 bg-gray-100 rounded" />
        ))}
      </div>
      {/* Table rows */}
      <div className="space-y-2">
        {[...Array(6)].map((_, rowIdx) => (
          <div key={rowIdx} className="flex gap-4">
            {[...Array(11)].map((_, colIdx) => (
              <div key={colIdx} className="h-6 w-24 bg-gray-200 rounded" />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
} 